const state = {
    currency: null,
    prePaidPaymentRes:null
   
};

const getters = {
    GET_SELECTED_CURRENCY: (state) => {
        return state.currency;
    },
    GET_PRE_PAID_PAY_RES: (state) => {
        return state.prePaidPaymentRes;
    },
    
};


const actions = {

    CLEAR_PREPAID_TOPUP_STORE: ({ commit }) => {
        commit('clearPrepaidTopUpStore');
    },
    SET_CURRENCY: ({ commit }, curr) => {

        commit('saveCurrency', curr);

    },
    SET_PRE_PAID_PAY_RES: ({ commit }, res) => {

        commit('savePrePaidPayRes', res);

    },
    

};


const mutations = {
    clearPrepaidTopUpStore: (state) => {
        state.currency = null;
        state.prePaidPaymentRes=null;
        
       
    },

    saveCurrency: (state, curr) => {
        state.currency = curr;
    },
    savePrePaidPayRes: (state, res) => {
        state.prePaidPaymentRes = res;
    },
    

};


export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}